import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import WaysCard from '../../components/WaysCard';
// CSS
import './about.css';
import Sec4aSVG from '../../assets/about/sec_2.svg';
import Sec4bSVG from '../../assets/about/about_mobile3.svg';
import AppNavBar from '../../helper/appbar';

const AboutPage = () => {
    return (
        <main>
            <AppNavBar navType={'dark'} />
            <section className='about_section_1'>
                <Container>
                    <Row>
                        <Col xs={12}>
                            <article>
                                <h1>Giving businesses the complete control</h1>
                                <p>We are a travel platform dedicated to changing the way business travel is done in Africa.</p>
                            </article>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='about_section_2'>
                <Container fluid>
                    <Row>
                        <Col sm={12} md={9} className="about_sec2_content">
                            <button>Our Story</button>
                            <p>We believe that when businesses trade outside of their borders, it increases the economic prosperity for the nation. However, African businesses have been constrained by the rigidity of business travel.</p>
                            <p>At Kardinal, we are giving you the tools to experience a different kind of business travel, one that gives you and your team full control with a mission to simplify trips for your business.</p>
                        </Col>
                        <Col sm={12} md={3}>
                            <img src={require("../../assets/about/about_2.png")} alt='sec2_about' loading='lazy' />
                            <div className='person-mobile'></div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='about_section_3'>
                <Container>
                    <Row>
                        <Col>
                            <h1>Discover a different way to travel</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='different-ways-container'>
                            <WaysCard
                                title={`Less admin, More impact`}
                                description={`Avoid unnecessary back-and-forth emails by controlling the entire process yourself`}
                            />
                            <WaysCard
                                title={`Transparency`}
                                description={`Plan your business trips without barriers. From booking, tracking, to payment, you keep a tab of everything on the go`}
                            />
                            <WaysCard
                                title={`Efficiency`}
                                description={`We will always be at the forefront of empowering you with simple, yet powerful tools that make your trip more enjoyable`}
                            />
                            <WaysCard
                                title={`All-star experience`}
                                description={`Communicate however you choose either by Whatsapp, email or a phone call, get a response in less than 1 minute`}
                            />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='about_section_4'>
                <Container fluid>
                    <Row>
                        <Col sm={12} lg={6}>
                            <h3 className='sec4-mob-h3'>Ready to take your business trip to the next level?</h3>
                            <img src={Sec4aSVG} className={"sec4a-img"} alt='sec4_about' loading='lazy' />
                            <img src={Sec4bSVG} className={"sec4b-img"} alt='sec4_about' loading='lazy' />
                        </Col>
                        <Col sm={12} lg={6} className='about_section_4_info'>
                            <h3 className='sec4-desk-h3'>Ready to take your business trip to the next level?</h3>
                            <ul>
                                <li>Flight, accommodation and car Search</li>
                                <li>Report on the go</li>
                                <li>Flexible Payment</li>
                                <li>Personalized services</li>
                            </ul>
                            <button className='about_signup_btn'>Sign up for free</button>
                            <button className='about_reqdemo_btn'>Request Demo</button>
                        </Col>
                    </Row>
                </Container>
            </section>
        </main>
    );
};

export default AboutPage;